import { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, ButtonVariants } from '@carboledger/ui';
import { ACCOUNT_SECTIONS, ROUTES } from '@/app/routes';
import { EmptyState, LoadingOverlay } from '@/components/feedback';
import { useTranslations } from '@/hooks';
import { useGetSiteFormQuery, useUpdateSiteMutation } from '../../api/sitesApi';
import { SiteForm } from './SiteForm';

export const EditSitePage = () => {
  const t = useTranslations();
  const navigate = useNavigate();
  const { siteId } = useParams();

  const { data: values, isLoading, isError } = useGetSiteFormQuery(siteId);
  const [updateSite, { isLoading: isSubmitting }] = useUpdateSiteMutation();

  const goToSites = useCallback(() => {
    navigate(ROUTES.accountSetup(ACCOUNT_SECTIONS.companyStructure));
  }, [navigate]);

  const handleSubmit = useCallback(
    async (nextValues) => {
      const result = await updateSite({ id: siteId, values: nextValues });
      if (result.error) return;
      goToSites();
    },
    [updateSite, siteId, goToSites],
  );

  if (isLoading) {
    return <LoadingOverlay label={t('COMMON_LOADING')} />;
  }

  if (isError || !values) {
    return (
      <EmptyState
        title={t('SITES_LOAD_ERROR')}
        action={
          <Button variant={ButtonVariants.secondary} onClick={goToSites}>
            {t('COMMON_BACK')}
          </Button>
        }
      />
    );
  }

  return (
    <SiteForm
      isEdit
      title={t('SITES_EDIT_TITLE')}
      initialValues={values}
      onSubmit={handleSubmit}
      onClose={goToSites}
      isSubmitting={isSubmitting}
    />
  );
};
